import registerDiagnosticsInfo from './utils/registerDiagnosticsInfo';
import initializeServiceRequestDiagnostics from './initializeServiceRequestDiagnostics';

export default function initializeDefaultDiagnostics() {
    registerDiagnosticsInfo();
    initializeServiceRequestDiagnostics();
}
